import { render, staticRenderFns } from "./DictionaryContent.vue?vue&type=template&id=9be98594&scoped=true&"
import script from "./DictionaryContent.vue?vue&type=script&lang=js&"
export * from "./DictionaryContent.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryContent.vue?vue&type=style&index=0&id=9be98594&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be98594",
  null
  
)

export default component.exports